import { delegate, disablePageScrolling } from './utils';

export default class LanguageSwitcher {
  constructor() {
    this.handleLanguageSwitch = this.handleLanguageSwitch.bind(this);
    this.closeLanguageSwitchModal = this.closeLanguageSwitchModal.bind(this);
    this.toggleLanguageSwitchModal = this.toggleLanguageSwitchModal.bind(this);

    document
      .querySelector('.language-switcher .current-site')
      ?.addEventListener('click', this.toggleLanguageSwitchModal);

    document
      .querySelector('.language-switcher-modal .close')
      ?.addEventListener('click', this.closeLanguageSwitchModal);

    delegate(
      'click',
      '.language-switcher-modal .corresponding-url',
      this.handleLanguageSwitch,
    );
  }

  toggleLanguageSwitchModal() {
    document
      .querySelector('.language-switcher-modal')
      ?.classList.toggle('hidden');
    disablePageScrolling();
  }

  closeLanguageSwitchModal() {
    this.toggleLanguageSwitchModal();

    document
      .querySelector('.language-switcher .all-sites-url')
      ?.classList.contains('hidden') && this.toggleCountryChangeWarning();
  }

  handleLanguageSwitch(event) {
    const target = event.target;
    if (!target) return;

    const { showWarning, href } = target.dataset;

    if (showWarning) {
      event.preventDefault();
      const countryChangeUrl = document.querySelector(
        '.language-switcher .country-change-url',
      );
      if (countryChangeUrl) countryChangeUrl.href = href;

      this.setTranslationText(target);
      this.toggleCountryChangeWarning();
    }
  }

  /**
   * Set translation text in country change warning modal based on the
   * Region and Language
   *
   * @param target
   */
  setTranslationText(target) {
    const { heading, firstPara, secondPara, btnText } = target.dataset;

    const headingEl = document.querySelector(
      '.country-change-warning .heading',
    );
    const firstParaEl = document.querySelector(
      '.country-change-warning .first-para',
    );
    const secondParaEl = document.querySelector(
      '.country-change-warning .second-para',
    );
    const btnTextEl = document.querySelector(
      '.country-change-warning .btn-text',
    );

    if (headingEl) headingEl.textContent = heading;
    if (firstParaEl) firstParaEl.textContent = firstPara;
    if (secondParaEl) secondParaEl.textContent = secondPara;
    if (btnTextEl) btnTextEl.textContent = btnText;
  }

  toggleCountryChangeWarning() {
    document
      .querySelector('.language-switcher .all-sites-url')
      ?.classList.toggle('hidden');
    document
      .querySelector('.language-switcher .country-change-warning')
      ?.classList.toggle('hidden');
  }
}
